// extracted by mini-css-extract-plugin
export var askRedoIcon = "_b-k";
export var askRedoTag = "_b-j";
export var askRedoText = "_b-l";
export var brandGroup = "_b-2";
export var chevron = "_b-p";
export var chevronActive = "_b-q";
export var chevronDown = "_b-f";
export var divider = "_b-r";
export var exitIcon = "_b-i";
export var exitTag = "_b-g";
export var exitText = "_b-h";
export var header = "_b-0";
export var logo = "_b-3";
export var navBar = "_b-1";
export var productIcon = "_b-5";
export var productName = "_b-6";
export var productTag = "_b-4";
export var profileAvatar = "_b-b";
export var profileGroup = "_b-a";
export var profileImage = "_b-c";
export var profileInitials = "_b-d";
export var progressFill = "_b-t";
export var progressTrack = "_b-s";
export var rightGroup = "_b-7";
export var stepLabel = "_b-n";
export var stepLabelActive = "_b-o";
export var stepLabels = "_b-m";
export var storeName = "_b-e";
export var themeIcon = "_b-9";
export var themeTag = "_b-8";